import {
  Create,
  Edit,
  Show,
  List,
  SimpleForm,
  SimpleShowLayout,
  TextInput,
  Datagrid,
  TextField,
  NumberField,
  DateField,
} from 'react-admin';
import Pagination from 'components/Pagination';
import { defaultPerPage } from 'utils/helpers';

const listFilters = [<TextInput label="Search" source="q" alwaysOn />];

export const AudienceList = props => (
  <List
    {...props}
    perPage={defaultPerPage}
    pagination={<Pagination />}
    filters={listFilters}
    sort={{ field: 'profiles_count', order: 'DESC' }}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <NumberField source="profiles_count" />
      <DateField source="created_at" />
    </Datagrid>
  </List>
);

export const AudienceCreate = props => (
  <Create {...props}>
    <SimpleForm redirect="/audiences">
      <TextInput source="name" />
    </SimpleForm>
  </Create>
);

export const AudienceEdit = props => (
  <Edit {...props} mutationMode="pessimistic">
    <SimpleForm redirect="/audiences">
      <TextInput source="name" />
    </SimpleForm>
  </Edit>
);

export const AudienceShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <NumberField source="profiles_count" />
      <DateField source="created_at" />
    </SimpleShowLayout>
  </Show>
);
